import { ref, shallowRef } from '@vue/reactivity';
import AMapLoader from '@amap/amap-jsapi-loader';
import Config from '@/config';
import GeocoderUtil from '@/utils/GeocoderUtil';
import AssetsUtil from '@/utils/AssetsUtil';
import CommonUtil from '@/utils/CommonUtil';
import { showToast } from 'vant';
import RouterUtil from '@/utils/RouterUtil';
import StorageUtil from '@/utils/StorageUtil';
import OrderApi from '@/api/order-api';
export default {
  name: 'OrderFinished',
  computed: {
    Config() {
      return Config;
    },
    CommonUtil() {
      return CommonUtil;
    }
  },
  setup() {
    const map = shallowRef();
    const geolocation = shallowRef();
    const geocoder = shallowRef();
    const weather = shallowRef();
    const driving = shallowRef();
    const vehicleTypes = shallowRef();
    const vehiclePrices = shallowRef();
    const vehicleTypeCheckedCount = shallowRef(0);
    const vehicleTypeUnCheckedCount = shallowRef(0);
    const position = shallowRef(Config.defaultPosition);
    const cityName = shallowRef('');
    const cityCode = shallowRef('');
    const lastCityCode = shallowRef('');
    const showWeather = shallowRef(false);
    const cityWeather = shallowRef('');
    const cityWeatherIcon = shallowRef(require('@/assets/icon/weather/default.svg'));
    const startAddress = shallowRef('');
    const startPosition = shallowRef([]);
    const endAddress = shallowRef('您要去哪里？');
    const endPosition = shallowRef([]);
    const kilometer = shallowRef('--');
    const drivingTime = shallowRef('--');
    const reserveDay = shallowRef(0);
    const reserveTime = shallowRef(['12', '00']);
    const awaitSecondInterval = ref();
    const orderData = ref();
    const orderDetailData = ref();
    const driverPosition = ref();
    const awaitSecond = ref(0);
    const startPointMarker = shallowRef();
    const endPointMarker = shallowRef();
    const driverMarker = shallowRef();
    const driverStatusInfoWindow = shallowRef();
    return {
      map,
      geolocation,
      geocoder,
      vehicleTypes,
      vehiclePrices,
      vehicleTypeCheckedCount,
      vehicleTypeUnCheckedCount,
      weather,
      driving,
      position,
      cityName,
      cityCode,
      lastCityCode,
      showWeather,
      cityWeather,
      cityWeatherIcon,
      startAddress,
      startPosition,
      endAddress,
      endPosition,
      kilometer,
      drivingTime,
      reserveDay,
      reserveTime,
      awaitSecondInterval,
      orderData,
      orderDetailData,
      driverPosition,
      awaitSecond,
      startPointMarker,
      endPointMarker,
      driverMarker,
      driverStatusInfoWindow
    };
  },
  mounted() {
    const that = this;
    this.orderData = StorageUtil.getObject('orderData');
    that.getOrderDetail();
    setTimeout(function () {
      //DOM初始化完成进行地图初始化
      that.initMap();
    }, 250);
    this.vehicleTypes = [{
      icon: require('@/assets/icon/vehicle/taxi.png'),
      name: '出租车',
      description: '传统出租 接单快速',
      pricePrefix: '预估',
      discount: 1.0,
      checked: true
    }, {
      icon: require('@/assets/icon/vehicle/taxi-new.png'),
      name: '新出租',
      description: '网约价格 超值畅行',
      pricePrefix: '预估',
      discount: 0.9,
      checked: true
    }];
    this.calculateVehicleTypeCheck();
    this.vehiclePrices = [];
    try {
      const orderInitiateData = StorageUtil.getObject('orderInitiateData');
      if (orderInitiateData) {
        this.startAddress = orderInitiateData.startAddress;
        this.startPosition = orderInitiateData.startPosition;
        this.endAddress = orderInitiateData.endAddress;
        this.endPosition = orderInitiateData.endPosition;
      }
    } catch (e) {} finally {
      // StorageUtil.remove("orderInitiateData");
    }
  },
  unmounted() {
    clearInterval(this.awaitSecondInterval);
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    RouterUtil() {
      return RouterUtil;
    },
    initMap() {
      const that = this;
      window._AMapSecurityConfig = {
        securityJsCode: '23ca323d154479c363c8c8df0b1ddb92'
      };
      AMapLoader.load({
        key: Config.mapKey,
        // 申请好的Web端开发者Key，首次调用 load 时必填
        version: Config.mapVersion,
        // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [
        // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        'AMap.Geocoder', 'AMap.Geolocation', 'AMap.Weather', 'AMap.Driving']
      }).then(AMap => {
        this.map = new AMap.Map('map', {
          //设置地图容器ID
          viewMode: '2D',
          //是否为3D地图模式
          zoom: 16,
          //初始化地图级别
          center: this.position //初始化地图中心点位置
          // mapStyle: "amap://styles/macaron",   //地图样式
          // dragEnable: false,
        });
        this.geolocation = new AMap.Geolocation({
          enableHighAccuracy: true,
          //是否使用高精度定位，默认:true
          timeout: 10000,
          //超过10秒后停止定位，默认：5s
          //position: 'RB',                         //定位按钮的停靠位置
          //offset: [10, 20],                       //定位按钮与设置的停靠位置的偏移量，默认：[10, 20]
          zoomToAccuracy: true //定位成功后是否自动调整地图视野到定位点
        });
        this.geocoder = new AMap.Geocoder({
          // city: "010",                            //城市设为北京，默认：“全国”
          // radius: 1000                            //范围，默认：500
        });
        this.weather = new AMap.Weather();
        this.driving = new AMap.Driving({
          map: this.map,
          //驾车策略，包括 LEAST_TIME，LEAST_FEE, LEAST_DISTANCE,REAL_TRAFFIC
          // policy: AMap.DrivingPolicy.LEAST_TIME,
          autoFitView: false,
          // panel: "panel"
          hideMarkers: true
        });
        this.map.on('moveend', function () {
          that.position = that.map.getCenter();
        });
        this.getOrderDetail();
        this.getCurrentPosition();
      }).catch(e => {
        console.error(e);
      });
    },
    getCurrentPosition() {
      const that = this;
      try {
        this.geolocation.getCurrentPosition(function (status, result) {
          if (status === 'complete') {
            that.position = result.position;
          } else {
            that.position = Config.defaultPosition;
          }
          // that.map.setCenter(that.position);
        });
      } catch (e) {
        that.position = Config.defaultPosition;
        // that.map.setCenter(that.position);
      }
    },
    getWeather(cityCode) {
      const that = this;
      that.weather.getLive(cityCode, function (err, data) {
        if (!err) {
          if (data.weather && data.temperature) {
            that.showWeather = true;
            that.cityWeather = data.temperature + '℃';
            that.cityWeatherIcon = AssetsUtil.getWeatherIcon(data.weather);
          } else {
            that.showWeather = false;
          }
        } else {
          that.showWeather = false;
        }
      });
    },
    getDriving(startPosition, endPosition) {
      const that = this;
      this.driving.search(startPosition, endPosition, function (status, result) {
        // result 即是对应的驾车导航信息，相关数据结构文档请参考：https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          if (result.routes) {
            const routes = result.routes;
            if (routes.length > 0) {
              const route = routes[0];
              const distance = parseFloat(route.distance);
              const tolls = parseFloat(route.tolls);
              that.kilometer = parseFloat(distance / 1000.00);
              that.drivingTime = route.time;
              let amount = 7.00;
              let valuationMileage = that.kilometer - 1.5;
              let additionalMileage = valuationMileage - 2.1;
              if (valuationMileage > 0) {
                if (valuationMileage > 2.1) {
                  amount += 2.1 * 2.0;
                  amount += additionalMileage * (2.00 * 1.4);
                } else {
                  amount += valuationMileage * 2.0;
                }
              }
              for (let i = 0; i < that.vehicleTypes.length; i++) {
                that.vehiclePrices[i] = (amount * that.vehicleTypes[i].discount + tolls).toFixed(2);
              }
              that.$forceUpdate();
            }
          }
        } else {
          console.error('获取驾车数据失败：' + result);
        }
      });
    },
    goBack() {
      StorageUtil.setObject('addressData', {
        type: 'end',
        address: '',
        position: ''
      });
      RouterUtil.back();
    },
    calculateVehicleTypeCheck() {
      if (this.vehicleTypes && this.vehicleTypes.length) {
        this.vehicleTypeCheckedCount = 0;
        this.vehicleTypeUnCheckedCount = 0;
        for (let i = 0; i < this.vehicleTypes.length; i++) {
          const vehicleType = this.vehicleTypes[i];
          if (vehicleType.checked) {
            this.vehicleTypeCheckedCount++;
          } else {
            this.vehicleTypeUnCheckedCount++;
          }
        }
      }
    },
    getOrderDetail() {
      const that = this;
      OrderApi.getOrderDetail(that.orderData.order_number).then(function (result) {
        if (result.success) {
          that.orderDetailData = result.orderDetail;
          try {
            that.orderDetailData.promotionsData = JSON.parse(that.orderDetailData.promotions);
            // eslint-disable-next-line no-empty
          } catch (e) {
            console.error(e);
          }
          if (that.orderDetailData.orderState !== 'ORDER_STATUS_COMPLETED') {} else {
            if (that.map) {
              that.startPosition = GeocoderUtil.BD09_GCJ02(parseFloat(that.orderDetailData.orderBeginAddressLongitude) / 1000000, parseFloat(that.orderDetailData.orderBeginAddressLatitude) / 1000000);
              that.endPosition = GeocoderUtil.BD09_GCJ02(parseFloat(that.orderDetailData.orderTargetAddressLongitude) / 1000000, parseFloat(that.orderDetailData.orderTargetAddressLatitude) / 1000000);
              const startPointIcon = new AMap.Icon({
                image: require('@/assets/icon/map/start-point.png'),
                size: [32, 32],
                imageSize: [32, 32]
              });
              if (that.startPointMarker) {
                that.startPointMarker.remove();
              }
              that.startPointMarker = new AMap.Marker({
                position: that.startPosition,
                icon: startPointIcon,
                offset: new AMap.Pixel(-13, -30)
              });
              that.map.add(that.startPointMarker);
              const endPointIcon = new AMap.Icon({
                image: require('@/assets/icon/map/end-point.png'),
                size: [32, 32],
                imageSize: [32, 32]
              });
              if (that.endPointMarker) {
                that.endPointMarker.remove();
              }
              that.endPointMarker = new AMap.Marker({
                position: that.endPosition,
                icon: endPointIcon,
                offset: new AMap.Pixel(-13, -30)
              });
              that.map.add(that.endPointMarker);

              // 覆盖物 |  四周边距，上、下、左、右 | 四周边距，上、下、左、右
              that.map.setFitView(null, false, [64, 64, 64, 64]);
            }
          }
        } else {
          that.$router.replace('/center');
        }
      }).catch(function (error) {
        console.error(error);
        showToast({
          message: '订单状态请求失败'
        });
      });
    }
  }
};